import { moveItems } from '../../shared/inventories'

export class ClientInventory {
  constructor(world) {
    this.world = world
    this.data = null
  }

  setInventory(inventory, gained) {
    this.data = inventory
    this.world.emit('inventory', inventory)
    if (gained?.length) this.world.emit('itemsGained', gained)
  }

  setInterface(currentInterface) {
    this.world.interface = currentInterface
    this.world.emit('interface', currentInterface)
  }

  moveInterfaceItems(data) {
    const srcInventory = data.srcType === 'local' ? this.data : this.world.interface?.inventory
    const destInventory = data.destType === 'local' ? this.data : this.world.interface?.inventory
    const hadItem = !!srcInventory?.slots?.[data.srcIdx]
    moveItems({ srcInventory, destInventory, srcIdx: data.srcIdx, destIdx: data.destIdx })
    if (hadItem) {
      const pos = this.world.controller.player?.getPosition()
      if (pos) this.world.audio.play({ name: 'snap', pitch: 0.05, volume: 1 }, pos.x, pos.y)
    }

    if (this.data) {
      this.world.emit('inventory', this.data)
    }
    if (this.world.interface) {
      this.world.emit('interface', this.world.interface)
    }

    this.world.send({ type: 'interfaceMove', ...data })
  }
}
